var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"dropdown-example-1"}},[_c('v-overflow-btn',{staticClass:"my-2",attrs:{"items":_vm.dropdown_font,"label":"Overflow Btn w/ disabled","disabled":"","target":"#dropdown-example-1"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }